"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/**
 * Scrolls smoothly to the anchor element specified by the href.
 *
 * @param {string} href - The href attribute value, expected to be an anchor link starting with '#'.
 * @param {Event} event - The event object associated with the click or navigation action.
 * @param {Function} onAfterScroll - A callback function to be executed after the scroll action is completed.
 */
const scrollToAnchor = (href, event, onAfterScroll) => {
  if (href?.startsWith('#')) {
    event.preventDefault();
    const target = document.getElementById(href.slice(1));
    target?.scrollIntoView({
      behavior: 'smooth'
    });
    window.location.hash = href;
    onAfterScroll(event);
  }
};
var _default = exports.default = scrollToAnchor;